export function OrderDocumentViewer({
  blobUrl,
  contentType,
}: {
  blobUrl: string | null;
  contentType: string | null;
}) {
  if (blobUrl === null) {
    return (
      <div className="px-4 py-8 text-center text-[length:var(--fs-sm)] text-[var(--ink-3)]">
        注文書は登録されていません
      </div>
    );
  }

  if (contentType?.includes("pdf")) {
    return (
      <iframe src={blobUrl} title="注文書プレビュー" className="block h-full w-full border-0" />
    );
  }

  if (contentType?.includes("image")) {
    return <img src={blobUrl} alt="注文書" className="h-auto max-w-full" />;
  }

  return (
    <div className="px-4 py-8 text-center text-[length:var(--fs-sm)] text-[var(--ink-3)]">
      プレビューできない形式です
    </div>
  );
}
